module.exports = __webpack_public_path__ + "img/doc.e7ec0aab.png";